import { FilterPropertyTypeEnum, TagUnion } from '@/types/schema';

export type TagAndPropertyOption = {
  id: string;
  name?: string;
  type: FilterPropertyTypeEnum;
  tag?: TagUnion;
};

export enum SystemProperty {
  OrgRoleId = 'orgRoleId',
  DepartmentId = 'departmentId',
  ManagerId = 'managerId',
  IndirectManagerId = 'indirectManagerId',
  CreatedById = 'createdById',
  CreatedAt = 'createdAt',
  Type = 'type',
  Email = 'email',
  EventType = 'eventType',
  EventDate = 'eventDate',
}
